import { PageParams, SortParamsModel } from "../core";

export interface LocationGridAdminFilterPostDtoGridRequestDto {
  pagination: PageParams;
  sort: SortParamsModel;
  filter: LocationGridAdminFilterPostDto;
}

export interface LocationGridAdminFilterPostDto {
  search?: string;
  brandId?: string;
  userId?: string;
  partnerIds?: string;
}

export interface LocationGridAccountItemGetDto {
  id: number;
  accountId: number;
  companyName: string;
  city: string;
  state: string;
  address: string;
  website: string;
  email: string;
  zip: string;
  phoneNumber: string;
  widgetsConfigured: boolean;
  accountName: string;
  managerName: string;
}
